/**
 * State Types with Type Safety.
 *
 * This file provides typed state path constants for accessing Redux state
 * in a type-safe manner. Each constant maps to its corresponding state interface.
 *
 * USAGE:
 * Instead of using string literals like 'features/base/jwt',
 * use stateType.base.jwt for type safety and autocomplete support.
 *
 * Example:
 * const jwt = state[stateType.base.jwt];
 */
export const stateType = {
    alwaysOnTop: 'features/always-on-top',
    analytics: 'features/analytics',
    app: 'features/app',
    authentication: 'features/authentication',
    avModeration: 'features/av-moderation',
    base: {
        audioOnly: 'features/base/audio-only',
        colorScheme: 'features/base/color-scheme',
        conference: 'features/base/conference',
        config: 'features/base/config',
        connection: 'features/base/connection',
        devices: 'features/base/devices',
        dialog: 'features/base/dialog',
        flags: 'features/base/flags',
        jwt: 'features/base/jwt',
        knownDomains: 'features/base/known-domains',
        lastN: 'features/base/lastn',
        libMeetHour: 'features/base/lib-meet-hour',
        logging: 'features/base/logging',
        media: 'features/base/media',
        modal: 'features/base/modal',
        mtApi: 'features/base/mtApi',
        netInfo: 'features/base/net-info',
        participants: 'features/base/participants',
        redux: 'features/base/redux',
        responsiveUi: 'features/base/responsive-ui',
        settings: 'features/base/settings',
        sounds: 'features/base/sounds',
        testing: 'features/base/testing',
        tracks: 'features/base/tracks',
        userInteraction: 'features/base/user-interaction'
    },
    billingCounter: 'features/billing-counter',
    calendarSync: 'features/calendar-sync',
    chat: 'features/chat',
    clickAndPledge: 'features/clickandpledge',
    conference: 'features/conference',
    connectionIndicator: 'features/connection-indicator',
    deepLinking: 'features/deep-linking',
    desktopPicker: 'features/desktop-picker',
    deviceSelection: 'features/device-selection',
    displayName: 'features/display-name',
    donorBox: 'features/donorbox',
    dropbox: 'features/dropbox',
    dynamicBranding: 'features/dynamic-branding',
    e2ee: 'features/e2ee',
    etherpad: 'features/etherpad',
    externalApi: 'features/external-api',
    feedBack: 'features/feedback',
    filmstrip: 'features/filmstrip',
    followMe: 'features/follow-me',
    genericIframe: 'features/genericIframe',
    gifs: 'features/gifs',
    googleApi: 'features/google-api',
    invite: 'features/invite',
    keyboardShortcuts: 'features/keyboard-shortcuts',
    largeVideo: 'features/large-video',
    lobby: 'features/lobby',
    localRecording: 'features/local-recording',
    mobile: {
        audioMode: 'features/mobile/audio-mode',
        backButton: 'features/mobile/back-button',
        background: 'features/mobile//background',
        callIntegration: 'features/mobile/call-integration',
        externalApi: 'features/mobile/external-api',
        fullScreen: 'features/mobile/full-screen',
        incomingCall: 'features/mobile/incoming-call',
        permissions: 'features/mobile/permissions',
        pictureInPicture: 'features/mobile/picture-in-picture',
        polyfils: 'features/mobile/polyfills',
        proximity: 'features/mobile/proximity',
        wakeLock: 'features/mobile/wake-lock',
        watchos: 'features/mobile/watchos'
    },
    noAudioSignal: 'features/no-audio-signal',
    noiseDetection: 'features/noise-detection',
    notifications: 'features/notifications',
    oldClientNotification: 'features/old-client-notification',
    overlay: 'features/overlay',
    participantsPane: 'features/participants-pane',
    powerMonitor: 'features/power-monitor',
    prejoin: 'features/prejoin',
    recentList: 'features/recent-list',
    recording: 'features/recording',
    rejoin: 'features/rejoin',
    remoteControl: 'features/remote-control',
    roomLock: 'features/room-lock',
    rtcstats: 'features/rtcstats',
    screenshotCapture: 'features/screenshot-capture',
    settings: 'features/settings',
    shareRoom: 'features/share-room',
    sharedVideo: 'features/shared-video',
    speakerStats: 'features/speaker-stats',
    subtitles: 'features/subtitles',
    talkWhileMuted: 'features/talk-while-muted',
    toolbox: 'features/toolbox',
    transcribing: 'features/transcribing',
    videoLayout: 'features/video-layout',
    videoMenu: 'features/video-menu',
    videoQuality: 'features/video-quality',
    videosipgw: 'features/videosipgw',
    virtualBackground: 'features/virtual-background',
    welcome: 'features/welcome',
    visitors: 'features/visitors'
};
